
import BaseSpinner from "@/components/base/BaseSpinner.vue";
import BookingHeader from "@/components/bookingflow/BookingHeader.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import TripAmendmentHeader from "./TripAmendmentHeader.vue";
import TripCalendar from "@/components/bookingflow/steps/tripdetails/TripCalendar.vue";
import TripDiscount from "@/components/bookingflow/steps/tripdetails/TripDiscount.vue";
import TripModeOfTravel from "@/components/bookingflow/steps/tripdetails/TripModeOfTravel.vue";
import TripPassengerSelect from "@/components/bookingflow/steps/tripdetails/TripPassengerSelect.vue";
import TripRoute from "@/components/bookingflow/steps/tripdetails/TripRoute.vue";
import useBookingCalendar from "@/composables/useBookingCalendar";
import useBookingSummaryEffect from "@/composables/useBookingSummaryEffect";
import useCalculatePrice from "@/composables/useCalculatePrice";
import useTripDetailsEffect from "@/composables/useTripDetailsEffect";
import { useBookingSummaryStore } from "@/store/basket";
import { useBookingStore } from "@/store/booking";
import { computed, defineComponent, onMounted  } from "vue";
import { useVuelidate } from "@vuelidate/core";

export default defineComponent({
	components: {
		BookingHeader,
		TripAmendmentHeader,
		TripModeOfTravel,
		TripRoute,
		TripPassengerSelect,
		TripCalendar,
		TripDiscount,
		BaseSpinner,
		BaseSection,
	},
	setup() {
		useBookingSummaryEffect();
		useTripDetailsEffect();
		const { calculate } = useCalculatePrice();
		const bookingSummary = useBookingSummaryStore();
		const bookingStore = useBookingStore();
		const { initializing } = useBookingCalendar(true);
		
		const isAmendmentMode = computed(() => {
			return bookingStore.getBooking.amendmentMode;
		});
		
		const isPartlyLocked = bookingStore.getBooking.outward?.isLocked ?? false;

		onMounted(() => {
			if(isAmendmentMode.value) {
				bookingSummary.setLoading(true);
				calculate().finally(() => {
					bookingSummary.setLoading(false)
				});
			}
		});
		
		const v$ = useVuelidate();
		
		return { isAmendmentMode, initializing, isPartlyLocked, v$ };
	},
});
